import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';

export class DispatchQVBus extends BaseBus
{
  CID(): any {
    return this.dispatchId;
    }
    get CUpdateDate(): Date {
        return this.updateDt;
    }
  constructor(data: DispatchQVBus) {
    super(data);
  }
  initialize(data: DispatchQVBus) {
    super.initialize(data);
      this.receivedDateTime = CommonFunctions.getDate(data.receivedDateTime);
      this.insertDt = CommonFunctions.getDate(data.insertDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
            //this.updateDt = date;
            this.updateUserid = userId;
        }
        else {
        }
    }
    get statusIdChanged(): boolean {
        return this.dispatchStatusId !== this.originalDispatchStatusId;
    }
    dispatchId: any;
    dispatchNumber: string;
    dispatchReason: string;
    customerName: string;
    locationName: string;
    receivedDateTime: Date;
    woNumber: string;
    poNumber: string;
    dispatchStatusName: string;
    accountClassName: string;
    priorityName: string;
    notToExceed: number;
    insertUserId: any;
    callbackNumber: string;
    callbackPerson: string;
    insertDt: Date;
    updateUserid: any;
    updateDt: Date;
    accountClassId: any;
    callbackId: any;
    customerId: any;
    locationId: any;
    priorityId: any;
    dispatchStatusId: any;
    dispatchRepairCatId: any;
    dispatchProblemCodeId: any;
    dispatchFailureCodesId: any;
    dispatchSummaryCodesId: any;
    originalDispatchStatusId: any;
    refTrackNbr: string;
    refTrackNbrDt: Date;
    refTrackNbrUserId: any;
    saveCode: string;
    isCallback: number;
    rankOrderId: string;
    quoteId: any;
}
